import styled, { css } from 'styled-components';
import { fontDisplay, fontUi } from '../../theme/typography';

export const StyledSliderDate = styled.span`
  ${fontUi};
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.text};
`;

export const StyledWrapper = styled.div`
  color: ${({ theme }) => theme.text};
  width: 100%;
  max-width: none;
  margin: 0;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  padding: 16px 16px 8px;
  box-sizing: border-box;
  overflow: hidden;

  .slick-slider {
    padding: 4px 28px 0;
    @media only screen and (max-width: 991px) {
      padding: 4px 28px 0;
    }
  }
  .slick-slide.slick-center a {
    margin-left: auto;
    margin-right: auto;
  }
  .slick-slide {
    height: auto;
    opacity: 0.45;
    font-family: 'Archivo', sans-serif;
    ${StyledSliderDate} {
      font-weight: 500;
    }
  }
  .slick-current {
    opacity: 1;
    ${StyledSliderDate} {
      font-weight: 600;
    }
  }

  .slick-next:before,
  .slick-prev:before {
    color: ${({ theme }) => theme.text};
  }
  .slick-arrow {
    width: 28px;
    height: 28px;
    background-color: ${({ theme }) => theme.nav};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    @media only screen and (max-width: 991px) {
      width: 25px;
      height: 25px;
    }
    &.slick-next,
    &.slick-prev {
      z-index: 10;
      &:hover {
        cursor: pointer;
        background-color: ${({ theme }) => theme.rail};
      }
      &:before {
        content: '';
      }
    }
    &.slick-next {
      right: 0;
    }
    &.slick-prev {
      left: 0;
    }
  }
`;

export const StyledSlider = styled.div`
  background-color: transparent;
`;

export const StyledMatchday = styled.p`
  ${fontUi};
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.textFaint};
  text-align: center;
  margin: 6px 0 0;
`;

export const StyledDateCard = styled.div`
  width: 100%;
  text-align: center;
  outline: none;
  cursor: pointer;
  padding: 8px 8px 4px;

  span {
    display: block;
    max-width: 100%;
    text-align: center;
    height: auto;
  }
`;

export const StyledFixturesContainer = styled.div`
  width: 100%;
  margin-top: 8px;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  background-color: transparent;
`;

export const StyledMatch = styled.div`
  position: relative;
  display: flex;
  min-height: 68px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
  padding: 8px 4px;
  box-sizing: border-box;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  z-index: 1;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  ${({ $hasUserTeam, theme }) => {
    if (!$hasUserTeam) return '';
    const fill = theme.isDark
      ? 'rgba(14, 74, 251, 0.24)'
      : 'rgba(14, 74, 251, 0.12)';
    return css`
      background: ${fill};
    `;
  }}
  ${({ $clickable, theme }) =>
    $clickable
      ? css`
          &:hover {
            background: ${theme.isDark
              ? 'rgba(255, 255, 255, 0.04)'
              : 'rgba(16, 38, 26, 0.04)'};
          }
        `
      : ''}
  &:last-of-type {
    border-bottom: 0;
  }
`;

export const StyledTeamName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${fontUi};
  font-size: 13px;
  font-weight: ${({ isTeamOwner }) => (isTeamOwner ? 700 : 500)};
  color: ${({ theme }) => theme.text};
  flex: 1;
  min-width: 0;
  justify-content: ${({ alignment }) => alignment};
  text-align: ${({ rightPart }) => (rightPart ? 'left' : 'right')};
  cursor: pointer;
  img {
    max-width: 28px;
    height: auto;
    margin: ${({ rightPart }) => (rightPart ? '0 10px 0 0' : '0 0 0 10px')};
    flex-shrink: 0;
  }
  @media only screen and (max-width: 991px) {
    flex-direction: ${({ rightPart }) =>
      rightPart ? 'column' : 'column-reverse'};
    text-align: center;
    font-size: 11px;
    img {
      margin: 0 0 4px;
    }
  }
`;

export const StyledGoals = styled.div`
  border-radius: 6px;
  ${fontDisplay};
  font-size: 14px;
  letter-spacing: 4px;
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.border};
  margin: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 56px;
  height: 28px;
  ${({ futureMatch, theme }) => {
    if (futureMatch) {
      return css`
        color: ${theme.textFaint};
        font-weight: 500;
        font-size: 12px;
        letter-spacing: 0.55px;
      `;
    }
  }}
`;

export const StyledNoMatches = styled.div`
  ${fontUi};
  min-height: 68px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.textFaint};
`;
